<template>
  <ul class="list-reset mb-2 text-xs">
    <li
      class="flex items-center text-xs text-blue-dark pl-4 pr-2 py-2 cursor-pointer hover:bg-blue-light hover:text-white"
      @click="showSubmenu =!showSubmenu"
    >
      <slot name="image"></slot>
      <span class="mb-0 ml-2 text-sm uppercase text-blue-dark font-normal mr-auto hover:text-white">
        {{title}}
      </span>
      <i
        v-if="showSubmenu == false"
        class="material-icons"
      >
        keyboard_arrow_down
      </i>
      <i
        v-if="showSubmenu == true"
        class="material-icons"
      >
        keyboard_arrow_up
      </i>
    </li>
    <ul
      v-show="showSubmenu"
      class="list-reset text-sm"
    >
      <slot></slot>
    </ul>
  </ul>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {
      showSubmenu: false
    };
  }
};
</script>




// WEBPACK FOOTER //
// MenuItem.vue?063530ec